import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { name: "b2b_contact_form" };
const _hoisted_2 = { class: "col-12 p-0 pb-3" };
const _hoisted_3 = { class: "col-12 p-0 pb-3" };
const _hoisted_4 = { class: "col-12 p-0 pb-3" };
const _hoisted_5 = { class: "col-12 p-0 pb-3" };
const _hoisted_6 = { class: "col-12 p-0 pb-3" };
const _hoisted_7 = { class: "col-12 p-0 pb-3" };
const _hoisted_8 = { class: "col-12 p-0 pb-3" };
import { ref } from 'vue';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { emailRequiredRule, firstNameRule } from '@/helpers/ValidationRules';
import axios from 'axios';
import BaseTextArea from '@/components/Base/Forms/Inputs/BaseTextArea.vue';
import eventBus from '@/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactFormGoecoImHandel',
    props: {
        formType: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const company = ref('');
        const firstname = ref('');
        const lastname = ref('');
        const email = ref('');
        const phone = ref('');
        const memberId = ref('');
        const message = ref('');
        const showErrors = ref(true);
        const sendMail = () => {
            axios
                .post('/goEco/contact', {
                request_type: props.formType,
                company: company.value,
                first_name: firstname.value,
                last_name: lastname.value,
                email: email.value,
                phone: phone.value,
                account_id: memberId.value,
                message: message.value,
            })
                .then(() => {
                showErrors.value = false;
                // Function for Popup button:
                const reload = () => {
                    window.location.reload();
                };
                // Popup:
                eventBus.emit('openInfoPopup', {
                    icon: 'success',
                    headline: 'Nachricht versendet',
                    message: 'Vielen Dank für Ihre Anfrage.',
                    buttonConfirmText: 'Schließen',
                    buttonConfirmFunction: reload,
                    persistent: true,
                });
            })
                .catch((error) => {
                let serverResponseErrors = '';
                Object.values(error.response.data.errors).forEach((e) => {
                    serverResponseErrors += e;
                    serverResponseErrors += '<br />';
                });
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Da ging was schief',
                    message: serverResponseErrors,
                });
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(BaseInput, {
                        name: "company",
                        modelValue: company.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((company).value = $event)),
                        id: "company",
                        placeholder: "Firma*",
                        class: _normalizeClass({ showValidationErrorsCssOverride: showErrors.value }),
                        rules: _unref(firstNameRule)
                    }, null, 8, ["modelValue", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(BaseInput, {
                        name: "lastname",
                        modelValue: lastname.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((lastname).value = $event)),
                        id: "lastname",
                        placeholder: "Nachname*",
                        class: _normalizeClass({ showValidationErrorsCssOverride: showErrors.value }),
                        rules: _unref(firstNameRule)
                    }, null, 8, ["modelValue", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(BaseInput, {
                        name: "firstname",
                        modelValue: firstname.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((firstname).value = $event)),
                        id: "firstname",
                        placeholder: "Vorname*",
                        class: _normalizeClass({ showValidationErrorsCssOverride: showErrors.value }),
                        rules: _unref(firstNameRule)
                    }, null, 8, ["modelValue", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(BaseEmailInput, {
                        name: "email",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((email).value = $event)),
                        label: "E-Mail-Adresse*",
                        id: "email",
                        class: _normalizeClass({ showValidationErrorsCssOverride: showErrors.value }),
                        rules: _unref(emailRequiredRule)
                    }, null, 8, ["modelValue", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(BaseInput, {
                        name: "phone",
                        modelValue: phone.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((phone).value = $event)),
                        id: "phone",
                        placeholder: "Telefonnummer (optional)"
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(BaseInput, {
                        name: "memberId",
                        modelValue: memberId.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((memberId).value = $event)),
                        id: "memberId",
                        placeholder: "Mitgliedsnummer (optional)"
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(BaseTextArea, {
                        modelValue: message.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((message).value = $event)),
                        name: "message",
                        label: "Nachricht",
                        placeholder: "Nachricht"
                    }, null, 8, ["modelValue"])
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "font7-responsive mb-2" }, "*Pflichtfeld", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-left font8-responsive mb-4" }, [
                    _createTextVNode(" Mit dem Absenden des Formulars erkläre ich mich mit der "),
                    _createElementVNode("a", {
                        href: "/datenschutz",
                        target: "_blank",
                        title: "Datenschutzbestimmungen",
                        class: "link-in-text"
                    }, " Datenschutzerklärung "),
                    _createTextVNode(" einverstanden. ")
                ], -1)),
                _createElementVNode("button", {
                    class: "buttonBase buttonGreen font6 w-sm-100 font6 mb-45",
                    type: "button",
                    id: "b2bSendContact",
                    onClick: _cache[7] || (_cache[7] = ($event) => (sendMail()))
                }, " Anfrage absenden ")
            ]));
        };
    }
});
